<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>
            <Header></Header>

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-9 form-request-content">
                            <div class="request-title">
                                <h1>Récapitulatif de la demande</h1>
                            </div>
                            <h3 class="title-content">Information salarié</h3>

                            <div class="exemption-details">
                                <div class="row" v-for="(value, label) in exemptionDetails" :key="label">
                                    <div class="col col-md-4 label">
                                        {{ label }}
                                    </div>
                                    <div class="col">
                                        {{ value }}
                                    </div>
                                </div>
                            </div>

                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                        name="exemption"
                                        method="post"
                                        enctype="multipart/form-data"
                                        novalidate="novalidate"
                                        class="needs-validation"
                                >
                                    <!-- Email -->
                                    <label
                                            class="required-field-asterisks required"
                                            for="exemption_email"
                                    >Email professionnel</label>
                                    <input
                                            type="email"
                                            id="exemption_email"
                                            class="form-control form-control-lg"
                                            :class="{ 'is-invalid': $v.formData.email.$error }"
                                            @input="delayTouch($v.formData.email)"
                                            placeholder="Email"
                                            v-model="formData.email"
                                    >
                                    <FormError error="Format de l'email incorrect"
                                               v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                                    ></FormError>
                                    <FormError error="Veuillez renseigner l’email"
                                               v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                                    ></FormError>
                                    <!-- Email -->

                                    <!-- Employer -->
                                    <div v-if="effectiveDues.length > 0"
                                         class="form-group"
                                    >
                                        <label class="required-field-asterisks"
                                               for="structure"
                                        >Employeur</label>
                                        <select id="structure"
                                                class="form-control select2"
                                                v-model.number="formData.dueId"
                                                @change="handleEffectiveDueChange()"
                                        >
                                            <option v-for="(due, index) in effectiveDues"
                                                    :key="index"
                                                    :value="due.id"
                                            >{{ due.companyName }} - {{ due.siren ? due.siren : due.siret }}</option>
                                        </select>
                                    </div>
                                    <!-- Employer -->

                                    <!-- Beneficiary -->
                                      <div class="form-group" v-if="handledFields.beneficiaryType && enterpriseUuid">
                                          <label class="required-field-asterisks"
                                                 for="beneficiary"
                                          >Salarié bénéficiaire</label>
                                          <select id="beneficiary"
                                                  class="form-control select2"
                                                  v-model="formData.beneficiaryId"
                                                  @change="handleBeneficiaryChange($event.target.value, enterpriseUuid)"
                                          >
                                              <option v-for="(beneficiary, index) in beneficiaries"
                                                      :key="index"
                                                      :value="beneficiary.id"
                                              >{{ beneficiary.shortTitle }}</option>
                                          </select>
                                    </div>
                                    <!-- Beneficiary -->

                                    <!-- Reason -->
                                    <div id="reason_group" class="form-group box-body">
                                        <label class="required-field-asterisks">Motif</label>
                                        <div class="icheck-primary radioNewResquestReasons"
                                             v-for="reason in particularCaseFilteredReasons"
                                             :key="reason.code"
                                        >
                                            <input
                                                    type="radio"
                                                    :id="reason.code"
                                                    :value="reason.id"
                                                    name="reason"
                                                    v-model="formData.exemptionReason.reasonId"
                                                    class="form-check-input"
                                            >
                                            <label class="form-check-label" :for="reason.code">
                                                <span class="radioLabel">{{ reason.titleHro }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <!-- Reason -->

                                    <!-- Reason Documents -->
                                    <ReasonDocuments
                                          v-if="exemption"
                                          :chosenReason.sync="chosenReason"
                                          :exemptionReason.sync="formData.exemptionReason"
                                          :expirationDate.sync="formData.exemptionReason.expirationDate"
                                          :exemptionStartDate="exemptionStartDate"
                                          :validationGroup="'edit'"
                                          :enterpriseSettings="enterpriseSettings"
                                          :isDraftPrefilledDate="isDraftPrefilledDate"
                                          ref="reasonDocuments"
                                    ></ReasonDocuments>
                                    <!-- Reason Documents -->

                                    <div class="form-group">
                                        <label for="exemptionDocument">La demande de dispense</label>
                                        <div class="input-group">
                                            <div>
                                                <span class="btn btn-primary btn-file">
                                                    <span v-if="!formData.exemptionDocument">Déposer la pièce justificative</span>
                                                    <span v-else>Changer de document</span>
                                                    <input type="file"
                                                           id="exemptionDocument"
                                                           @change="addDocument($event)"
                                                    >
                                                </span>
                                                <a
                                                   href=""
                                                   download
                                                   class="ml-2"
                                                   v-if="formData.exemptionDocument"
                                                   @click.prevent=""
                                                >{{ formData.exemptionDocument.content.name }}</a>
                                                <a class="close ml-1"
                                                   href=""
                                                   v-if="formData.exemptionDocument"
                                                   @click.prevent="deleteDocument"
                                                >×</a>
                                                <FormError v-if="!$v.formData.exemptionDocument.validFileSize
                                                                 && $v.formData.exemptionDocument.$dirty"
                                                           error="La taille du fichier ne doit pas dépasser 4MO"
                                                ></FormError>
                                                <FormError v-if="!$v.formData.exemptionDocument.validMimeType
                                                                 && $v.formData.exemptionDocument.$dirty"
                                                           error="Les formats des fichiers autorisés sont .pdf"
                                                ></FormError>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div class="col-md-3 col-xl-3"></div>

                        <div class="input-group col-md-9 mx-sm-auto my-md-4">
                            <button class="btn btn-success btn-lg linktoemployee"
                                    :disabled="isButtonDisabled"
                                    @click.prevent="save"
                            >
                                <span>Enregistrer les modifications</span>
                                <span
                                        v-if="isLoading"
                                        class="spinner-border spinner-border-sm ml-2"
                                        role="status"
                                        aria-hidden="true"
                                ></span>
                            </button>
                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';
    import moment from 'moment';

    import Sidebar from '../../components/Sidebar';
    import Footer from '../../components/Footer';
    import FormError from '../../components/FormError';
    import ReasonDocuments from '../../components/ReasonDocuments';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import ExemptionManager from '../../service/manager/exemptionManager';
    import Header from '../../components/Header';
    import ExemptionHandleReasonChangeMixin from '../../mixins/exemptionHandleReasonChangeMixin';
    import {
        fetchExemptionById,
        fetchPartialBeneficiaries,
        updateExemption
    } from '../../service/api/exemptions.api';
    import { filterRenewReasons, getExemptionStatusLabel } from '../../utils/utils';
    import { fileMineTypeConstraint, filesizeConstraint } from '../../utils/validation';

    export default {
        mixins: [ValidationDelayTouch, ExemptionHandleReasonChangeMixin],
        data() {
            return {
                formData: {
                    email: '',
                    exemptionDocument: null,
                    beneficiaryId: null,
                    dueId: null,
                    exemptionReason: {
                        reasonId: 0,
                        documents: [],
                        expirationDate: ''
                    }
                },
                reasons: [],
                beneficiaries: [],
                effectiveDues: [],
                chosenReason: null,
                exemption: null,
                isLoading: false,
            };
        },
        computed: {
            ...mapGetters({
                baseReasons: 'baseReasons',
                filteredBaseReasons: 'filteredBaseReasons',
                enterpriseSettings: 'enterpriseSettings',
                enterpriseUuid: 'enterpriseSettingsUuid',
            }),
            particularCaseFilteredReasons() {
                return filterRenewReasons(this.exemption, this.reasons);
            },
            reason() {
                return this.formData.exemptionReason.reasonId;
            },
            isButtonDisabled() {
                if (!this.exemption) {
                    return true;
                }

                return this.$v.$invalid || this.$refs.reasonDocuments.$v.$invalid || this.isLoading;
            },
            handledFields() {
                const {
                    beneficiaryTypeHandled: beneficiaryType = false,
                    externalIdHandled: externalId = false,
                } = this.enterpriseSettings || {};

                return { beneficiaryType, externalId };
            },
            exemptionStartDate() {
                if (!this.exemption) {
                    return null;
                }

                if (!this.exemption.startDate) {
                    return moment(this.exemption.createdAt).format('DD/MM/YYYY');
                }

                return moment(this.exemption.startDate).format('DD/MM/YYYY');
            },
            isDraftPrefilledDate() {
                return this.exemption
                    && this.exemption.status === 'draft'
                    && !!this.formData.exemptionReason.expirationDate;
            },
            exemptionDetails() {
                if (!this.exemption) {
                    return {};
                }

                return {
                    'Etat': getExemptionStatusLabel(this.exemption.status),
                    'Civilité': this.exemption.civility,
                    'Nom': this.exemption.lastName,
                    'Prénom': this.exemption.firstName,
                    'Nom de naissance': this.exemption.birthName,
                    'Date de naissance': this.exemption.birthDate ? new Date(this.exemption.birthDate).toLocaleDateString() : '',
                    'Date de début de la dispense': this.exemption.startDate ? new Date(this.exemption.startDate).toLocaleDateString() : '',
                    ...(this.handledFields.externalId && { 'Matricule': this.exemption.externalId }),
                };
            }
        },
        watch: {
            async reason(reasonId) {
                if (!Number.isInteger(reasonId)) {
                    this.chosenReason = null;
                    return;
                }
                await this.fetchChosenReason(reasonId);
            },
        },
        async mounted() {
            await this.fetchExemption();
        },
        methods: {
            getExemptionStatusLabel,
            ...mapActions({
                fetchBaseReasons: 'fetchBaseReasons'
            }),
            addDocument(event) {
                this.formData.exemptionDocument = { typeCode: 'SD0', content: event.target.files[0] };
                this.$v.formData.exemptionDocument.$touch();
            },
            deleteDocument() {
                this.formData.exemptionDocument = null;
            },
            async save() {
                this.isLoading = true;
                try {
                    await updateExemption(this.exemption.id, this.formData);
                    this.isLoading = false;
                    await this.$router.push({ name: 'exemption-list'});
                } catch ({ response }) {
                    this.isLoading = false;
                    let message;
                    if (response?.data?.violations?.length) {
                        message = response.data.violations.map(v => v.title).join('<br>');
                    } else {
                        message = response?.data?.detail ?? 'Une erreur est survenue. Veuillez réessayer.';
                    }
                    this.$swal({
                        icon: 'error',
                        html: message,
                        timer: 15000,
                        timerProgressBar: true,
                        showConfirmButton: true,
                        confirmButtonText: 'Fermer',
                    });
                }
            },
            async fetchExemption() {
                const { data } = await fetchExemptionById(this.$route.params.exemptionId);
                this.exemption = data;
                await this.$store.dispatch('setSettingsContext', { enterpriseUuid: data.enterprise.uuid });
                this.formData = {
                    ...this.formData,
                    ... await ExemptionManager.createEditFormData(data)
                }
                await this.fetchDependencies(data.enterprise.uuid);
            },
            async fetchDependencies(enterpriseUuid) {
                await this.fetchBaseReasons(enterpriseUuid);
                await this.fetchReasons();
                this.beneficiaries = await fetchPartialBeneficiaries();
                await this.fetchStructures();
            }
        },
        validations: {
            formData: {
                email: {
                    required,
                    email
                },
                exemptionDocument: {
                    validFileSize: filesizeConstraint(4000000),
                    validMimeType: fileMineTypeConstraint(['application/pdf'])
                }
            }
        },
        components: {
            Header,
            Sidebar,
            Footer,
            FormError,
            ReasonDocuments
        }
    }
</script>

<style scoped lang="scss">
    .exemption-details {
        margin: 20px 0 30px;

        .row {
            min-height: 24px;
            margin: 4px 0;
            background: #f9fafc;
        }

        .label {
            font-size: 14px;
            font-weight: 700;
        }
    }
</style>
